var e={settlementId:["streetId","street","building","postalCode","addressId"],streetId:["addressId","building","postalCode"]};export{e as DOWNSTREAM_FIELDS};
//# sourceMappingURL=utils.js.map